import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { List, ListItem, ListItemText, Collapse, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDataProvider } from 'react-admin';

const SectionsTreeView = ({ selected, onSelect, searchQuery }) => {
  const dataProvider = useDataProvider();
  const [nodes, setNodes] = useState([]);
  const [expanded, setExpanded] = useState([]);

  useEffect(() => {
    dataProvider
      .getList('company_sections', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'id', order: 'ASC' },
        filter: { company: localStorage.getItem('company') },
      })
      .then(({ data }) => {
        // Convert flat list to tree
        const map = {};
        const tree = [];
        data.forEach(item => (map[item.id] = { ...item, children: [] }));
        data.forEach(item => {
          if (item.upper_section && map[item.upper_section]) {
            map[item.upper_section].children.push(map[item.id]);
          } else {
            tree.push(map[item.id]);
          }
        });
        setNodes(tree);
      });
  }, [dataProvider]);

  const filterNodes = (items) => {
    if (!searchQuery) return items;
    
    return items.filter(node => {
      const matchesSearch = node.title.toLowerCase().includes(searchQuery.toLowerCase());
      const hasMatchingChildren = filterNodes(node.children).length > 0;
      
      // Auto-expand nodes with matching children
      if (hasMatchingChildren && !expanded.includes(node.id)) {
        setExpanded(prev => [...prev, node.id]);
      }
      
      return matchesSearch || hasMatchingChildren;
    });
  };

  const handleToggle = (nodeId) => {
    setExpanded((prev) => {
      if (prev.includes(nodeId)) {
        return prev.filter(id => id !== nodeId);
      }
      return [...prev, nodeId];
    });
  };

  const renderTree = (items, level = 0) =>
    items.map(node => (
      <div key={node.id}>
        <ListItem 
          button 
          onClick={() => onSelect(node.id)}
          selected={String(selected) === String(node.id)}
          style={{ paddingLeft: level * 20 + 16 }}
        >
          {node.children.length > 0 && (
            <IconButton 
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleToggle(node.id);
              }}
            >
              {expanded.includes(node.id) ? <ExpandMoreIcon /> : <ChevronRightIcon />}
            </IconButton>
          )}
          <ListItemText primary={node.title} />
        </ListItem>
        {node.children.length > 0 && (
          <Collapse in={expanded.includes(node.id)}>
            {renderTree(node.children, level + 1)}
          </Collapse>
        )}
      </div>
    ));

  return (
    <List sx={{ flexGrow: 1, overflowY: 'auto' }}>
      {renderTree(filterNodes(nodes))}
    </List>
  );
};

export default SectionsTreeView;
